// Shared bits for the Pipeline page's Reverse / Commercial tabs.

// The API's keys arrive lowercased already; this keeps us safe if one doesn't (same as ApplicationsView).
export function lowerKeys(obj) {
  const out = {};
  Object.keys(obj || {}).forEach(k => { out[k.toLowerCase()] = obj[k]; });
  return out;
}

// Referral times are stored in UTC but come back without a zone ("2026-10-28T14:05:00"), which the
// browser would read as local time. Returns a Date (or null) so tables can sort and format it.
export function utcDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  const str = String(value);
  const d = new Date(/(Z|[+-]\d\d:?\d\d)$/.test(str) ? str : str + 'Z');
  return isNaN(d.getTime()) ? null : d;
}

export function formatWhen(date) {
  if (!date) return '';
  const diff = (Date.now() - date.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return date.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}
